import { isRunningStatus } from '@agilelab/plugin-wb-builder-common';
import { useEnabledFeatures } from '@agilelab/plugin-wb-platform';
import { FC, lazy, Suspense, useEffect, useMemo } from 'react';
import { useEditorPageContext } from '../context/useEditorPageContext';
import { AssistantDrawer } from './AssistantDrawer/AssistantDrawer';
import { AsyncTestTableRow } from './AsyncTestTableRow';
import { TaskDrawer } from './TaskDrawer/TaskDrawer';
import { TestCurrentEmptyState } from './TestCurrentEmptyState';
import { TestCurrentRow } from './TestCurrentRow';
import { TestTableLoading } from './TestTableLoading';

const LazyAutofixDrawer = lazy(() =>
  import('../AutofixDrawer/AutofixDrawer').then(m => ({
    default: m.AutofixDrawer,
  })),
);

export const TestCurrent: FC = () => {
  const {
    selectedTask,
    setSelectedTask,
    showCurrentTest,
    lastTestState,
    descriptorStateWithComponents,
    environment,
    monacoEditorRef,
    fetchAssistant,
    testLoading,
  } = useEditorPageContext();

  const { data: features } = useEnabledFeatures();

  useEffect(() => {
    fetchAssistant();
  }, [fetchAssistant]);

  const isRunning = useMemo(() => {
    return (
      lastTestState.value &&
      (isRunningStatus(lastTestState.value.status) ||
        lastTestState.value.tasks.some(task => isRunningStatus(task.status)))
    );
  }, [lastTestState.value]);

  const showEmptyState =
    (!lastTestState.value ||
      !showCurrentTest ||
      lastTestState.value?.environment !== environment) &&
    !testLoading;

  return (
    <>
      {showEmptyState && <TestCurrentEmptyState />}
      {isRunning && lastTestState.value && (
        <AsyncTestTableRow test={lastTestState.value} />
      )}
      {!showEmptyState && (
        <TestTableLoading>
          <TestCurrentRow
            testLoading={testLoading}
            test={lastTestState.value}
            loadingText={
              descriptorStateWithComponents.loading
                ? 'Fetching the descriptor'
                : 'Validating the descriptor'
            }
          />
        </TestTableLoading>
      )}
      <TaskDrawer
        task={selectedTask}
        open={Boolean(selectedTask)}
        onClose={() => {
          setSelectedTask(null);
          monacoEditorRef.current?.applyDecorations(
            undefined,
            undefined,
            'white',
          );
        }}
      />
      <AssistantDrawer />
      {features.wittyAutofixEnabled && (
        <Suspense fallback={null}>
          <LazyAutofixDrawer />
        </Suspense>
      )}
    </>
  );
};
